module.exports = __webpack_public_path__ + "img/close.ec7f1191.svg";